// axiosInstance.ts
import axios from 'axios';
import { logoutOrganization } from '../Actions/Organization/AuthActions';
import store from '../store';  // Import your Redux store
// import { useNavigate } from 'react-router-dom';


// Create an Axios instance
const state = store.getState();
const token = state.auth.org?.token;  // Replace with your actual path to the token in the state

// If token exists, add it to the request headers
const OrganizationAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_HOST ,  // Change this to your base URL
  headers: {
    'Content-Type': 'application/json'
  },
});

OrganizationAxiosInstance.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const token = state.auth.org?.token; // Update path to your actual token

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 errors globally


export default OrganizationAxiosInstance;
